import type { Strings } from '../../i18n/strings';
import type { ChecklistItem } from './api';

// The setup checklist's item names (spec A3), shared by the platform admin's
// school page and the head of school's read-only School status.
export function checklistLabel(t: Strings, k: ChecklistItem['key'], sandbox: boolean): string {
  switch (k) {
    case 'safety_net':
      return t['pa.ckSafetyNet'];
    case 'paperwork':
      return sandbox ? t['pa.ckPaperworkSandbox'] : t['pa.ckPaperworkCustomer'];
    case 'profile':
      return t['pa.ckProfile'];
    case 'classes':
      return t['pa.ckClasses'];
    case 'staff':
      return sandbox ? t['pa.ckStaffSandbox'] : t['pa.ckStaffCustomer'];
    case 'teachers_assigned':
      return t['pa.ckTeachers'];
    case 'notice':
      return t['pa.ckNotice'];
    case 'dpo':
      return t['pa.ckDpo'];
    case 'dedicated':
      return t['pa.ckDedicated'];
    case 'safety_net_reviewed':
      return t['r4.ck.safety_net_reviewed'];
    case 'languages_reviewed':
      return t['r4.ck.languages_reviewed'];
    case 'wilma_link':
      return t['pa.ckWilmaLink'];
    case 'helpline':
      return t['pa.ckHelpline'];
  }
}
